import React from "react";
import V20Embed from "@/components/mock/V20Embed";
export default function Migration() {
  return <V20Embed view="migration" testid="migration-view" />;
}
